import { Text } from '@factorialco/deprecated-design-system'

interface LocationProps {
  locationName: string | null
}

export default function Location({ locationName }: LocationProps) {
  if (!locationName) return <>-</>

  return <Text.Normal>{locationName}</Text.Normal>
}
